if(!customElements.get("finance-years-addorment")) customElements.define("finance-years-addorment", class extends HTMLElement {
    static get observedAttributes() {
        return ['value'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "value":
                this.updateText(Number.parseInt(newValue));
                break;
        }
    }

    connectedCallback() {
        this.updateText(Number.parseInt(this.getAttribute('value')));
    }

    updateText(value) {
        if (typeof value !== 'undefined' && !Number.isNaN(value) && Number.isFinite(value)) {
            if (value === 1 || (value > 20 && value % 10 === 1)) {
                this.innerHTML = "год";
                return;
            }
            const godaCases = [2, 3, 4];
            if (godaCases.indexOf(value) >= 0 || (value > 20 && godaCases.indexOf(value % 10) >= 0)) {
                this.innerHTML = "года";
                return;
            }
            this.innerHTML = "лет";
        }
    }
});
